module.exports = __webpack_public_path__ + "mx.33c30b31fa0b2d621d4b.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/mx.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/mx.svg
// module chunks = styles